import React from 'react';
import { Typeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import RangePicker from './RangePicker';
import './selectMesSalida.css';

const MesSalida = ({ ActualizarFecha, t, mesSalida, productoDisponible }) => {
  const mobile = typeof window === 'undefined' ? 0 : window.screen.width;
  const countriesForRangePicker = [4];

  const updateDate = (e, date) => {
    if (date) {
      ActualizarFecha(e, date);
    } else {
      if (window.screen.width < 768) {
        ActualizarFecha(e.target.value);
      } else {
        ActualizarFecha(e[0].value);
      }
    }
  };

  const handleMonths = () => {
    const lang = t('searcher.monthLang');
    const monthList = [];
    for (let i = 0; i < 13; i++) {
      const date = moment().locale(lang).add(i, 'month').format('MM-YYYY');
      const month = moment().locale(lang).add(i, 'month').format('MMMM YYYY');
      monthList[i] = [date, month];
    }
    return monthList;
  };

  const renderMonth = () => {
    const lang = t('searcher.monthLang');
    const monthList = handleMonths();
    const optionsList = [];
    for (let i = 0; i < monthList.length; i++) {
      optionsList.push(
        <option
          key={i}
          selected={monthList[i][0] === mesSalida}
          value={monthList[i][0]}
        >
          {monthList[i][1]}
        </option>
      );
    }
    moment.locale(lang, optionsList);
    return optionsList;
  };

  const renderMenu = (menuprops) => {
    const monthList = handleMonths();
    const availableDate = [];
    if (productoDisponible) {
      productoDisponible.map((res) => {
        const formatted = moment(res.period).format('MM-YYYY');
        availableDate.push(formatted);
      });
    }
    const items = monthList.map((item) => {
      return (
        <MenuItem key={item[0]} option={{ value: item[0], label: item[1] }}>
          <div className='block px-2 py-2'>
            <div className='mes-salida-select'>
              {item[1]}
              {availableDate.includes(item[0]) ? (
                <div className='pull-right'>
                  <span className='color-marca-blanca-texto'>
                    <i className='far fa-calendar-alt' />
                  </span>
                </div>
              ) : null}
            </div>
          </div>
        </MenuItem>
      );
    });
    return (
      <Menu id={'menu'} {...menuprops} paginate={false}>
        {items}
      </Menu>
    );
  };

  return (
    <>
      {mobile < 768 ? (
        <select
          role='button'
          className='mes-salida-select input-paquetes border-l-0 border-t-0 border-r-0'
          onChange={updateDate}
          data-name='MesSalida'
          name='fecha_salida'
          value={mesSalida !== '' ? mesSalida : 'Selecciona el mes'}
          required
        >
          <option value='Selecciona el mes'>{t('searcher.date')}</option>
          {renderMonth()}
        </select>
      ) : (
        <div
          id='meses'
          className='mes-salida-select input-paquetes'
          role='button'
        >
          {countriesForRangePicker.includes(
            parseInt(localStorage.getItem('paisId'))
          ) ? (
            <RangePicker onChange={updateDate} />
          ) : (
            <Typeahead
              id='mes-salida-b'
              placeholder={t('searcher.date')}
              onChange={updateDate}
              renderMenu={renderMenu}
              options={[]}
              labelKey='label'
            />
          )}
        </div>
      )}
    </>
  );
};

export default withTranslation(['layout'])(MesSalida);
